export default __webpack_public_path__ + "static/media/downBubble.9da56b52.svg";